import React from "react"
import contactForm from "./contactForm.module.scss"
import text from "../styles/typography.module.scss"
import button from "./button.module.scss"

export default props => {
  return (
    <form className={contactForm.formGrid}>
      <div className={contactForm.layout}>
        <label htmlFor={"name"} className={text.paragraph}>
          Name
        </label>
        <input type="text" id={"name"} className={contactForm.input}></input>
      </div>
      <div className={contactForm.layout}>
        <label htmlFor={"email"} className={text.paragraph}>
          E-mail
        </label>
        <input type="text" id={"email"} className={contactForm.input}></input>
      </div>
      <div className={contactForm.layout}>
        <label htmlFor={"phone"} className={text.paragraph}>
          Phone
        </label>
        <input type="text" id={"phone"} className={contactForm.input}></input>
      </div>
      <div className={contactForm.layout}>
        <label htmlFor={"web"} className={text.paragraph}>
          Company Website
        </label>
        <input type="text" id={"web"} className={contactForm.input}></input>
      </div>
      <div className={contactForm.messageBox}>
        <label htmlFor={"message"} className={text.paragraph}>
          Message
        </label>
        <textarea
          type="text"
          id={"message"}
          className={contactForm.input}
        ></textarea>
      </div>
      <button className={`${button.btn} ${button.secondary}`}>Send</button>
    </form>
  )
}
